const ClientComponent = () => import('@/views/business/client/ClientView')

export default [
    {
        path:'/ClientIndex',
        name:'ClientComponent',
        component:ClientComponent
    }
]